<template>
  <span v-if="savePercentageText" :class="customClass">{{ savePercentageText }}</span>
</template>

<script setup>
  import { computed, toRefs } from 'vue';

  const props = defineProps({
    comparePrice: {
      type: [Number, String],
      default: null,
    },
    currentPrice: {
      type: [Number, String],
      default: null,
    },
    discountPercentage: {
      type: [Number, String],
      default: null,
    },
    labelPrefix: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: 'pm__price-saveText',
    },
  });

  const { comparePrice, currentPrice, discountPercentage, labelPrefix } = toRefs(props);

  const normalizePrice = (value) => {
    if (value === null || value === undefined || value === '') return null;

    const normalizedValue = typeof value === 'string' ? Number(value.replace(/[^0-9.-]/g, '')) : Number(value);

    return Number.isFinite(normalizedValue) ? normalizedValue : null;
  };

  const savePercentageText = computed(() => {
    const normalizedDiscountPercentage = normalizePrice(discountPercentage.value);

    if (normalizedDiscountPercentage !== null) {
      const percentage = Math.round(normalizedDiscountPercentage);

      return percentage > 0 ? `${labelPrefix.value}${percentage}% Off` : '';
    }

    const normalizedComparePrice = normalizePrice(comparePrice.value);
    const normalizedCurrentPrice = normalizePrice(currentPrice.value);

    if (
      normalizedComparePrice === null ||
      normalizedCurrentPrice === null ||
      normalizedComparePrice <= 0 ||
      normalizedCurrentPrice >= normalizedComparePrice
    ) {
      return '';
    }

    const percentage = Math.round(((normalizedComparePrice - normalizedCurrentPrice) / normalizedComparePrice) * 100);

    return percentage > 0 ? `${labelPrefix.value}${percentage}% Off` : '';
  });
</script>
